import React from 'react'
import {Button} from 'reactstrap'
import {UndoIcon, RedoIcon, HandMoveIcon, ZoomInIcon, ZoomOutIcon} from '../../../../../common/icons'

const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform)
const modKey = isMac ? '\u2318' : 'Ctrl'

function RemoveBgPreviewToolbar({
    ready = false,
    tool = 'brush',
    onSetTool,
    canUndo = false,
    canRedo = false,
    onUndo,
    onRedo,
    zoomPercent = 100,
    onZoomIn,
    onZoomOut,
}) {
    return (
        <div className="RemoveBgEditor__PreviewToolbar">
            <div className="RemoveBgEditor__ToolbarGroup">
                <Button
                    className="RemoveBgEditor__ToolbarBtn"
                    color="light"
                    disabled={!ready || !canUndo}
                    onClick={onUndo}
                    title={`Undo (${modKey}+Z)`}
                >
                    <UndoIcon width={20} height={20} />
                </Button>
                <Button
                    className="RemoveBgEditor__ToolbarBtn"
                    color="light"
                    disabled={!ready || !canRedo}
                    onClick={onRedo}
                    title={`Redo (${modKey}+Shift+Z)`}
                >
                    <RedoIcon width={20} height={20} />
                </Button>
            </div>

            <div className="RemoveBgEditor__ToolbarToolsRow">
                <Button
                    className={`RemoveBgEditor__ToolbarBtn RemoveBgEditor__ToolbarBtn--white ${tool === 'hand' ? 'RemoveBgEditor__ToolbarBtn--active' : ''}`}
                    color="light"
                    disabled={!ready}
                    onClick={() => onSetTool?.(tool === 'hand' ? 'brush' : 'hand')}
                    title="Hand tool (hold Space)"
                >
                    <HandMoveIcon width={20} height={20} />
                </Button>

                <div className="RemoveBgEditor__ZoomGroup">
                    <Button
                        className="RemoveBgEditor__ToolbarBtn RemoveBgEditor__ToolbarBtn--white"
                        color="light"
                        disabled={!ready}
                        onClick={onZoomOut}
                        title="Zoom out"
                    >
                        <ZoomOutIcon width={20} height={20} />
                    </Button>
                    <span className="RemoveBgEditor__ZoomDisplay">{zoomPercent}%</span>
                    <Button
                        className="RemoveBgEditor__ToolbarBtn RemoveBgEditor__ToolbarBtn--white"
                        color="light"
                        disabled={!ready}
                        onClick={onZoomIn}
                        title="Zoom in"
                    >
                        <ZoomInIcon width={20} height={20} />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default RemoveBgPreviewToolbar
